<template>
  <div class="search-dropdown-wrapper" :class="{'disabled': disabled}">
    <div class="dropdown-toggle" @click="toggleDropdown()">
      <div class="selected-option" v-if="dropType !== 'simple'">{{selectedOption ? (`${selectedOption.firstName} ${selectedOption.lastName}`) : title }}</div>
      <div class="selected-option" v-else>{{selectedOption ? (`${selectedOption}`) : title }}</div>
      <img class="arrow" src="../assets/img/arrow_down.png">
    </div>
    <div class="dropdown dropdown-active" v-show="dropdownActive">
      <div class="search" v-if="search"><input placeholder="Type here to search" v-model="searchStr"></div>
      <div class="clear-filter" @click="clearFilter()" v-if="searchStr !== null && searchStr !== ''">
        <img src="../assets/img/clear_x.png">
      </div>
      <div class="options-scroll" v-if="dropType !== 'simple'">
        <div v-for="(item, itemIndex) in filteredItems" :key="`item-${itemIndex}`" :class="{'dropdown-option': true}" @click="selectOption(item)">{{(`${item.firstName} ${item.lastName}`)}}</div>
      </div>
      <div class="options-scroll" v-else>
        <div v-for="(item, itemIndex) in filteredItems" :key="`item-${itemIndex}`" :class="{'dropdown-option': true}" @click="selectUserType(item)">{{(`${item}`)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SearchDropdown',
  props: {
    modelValue: String,
    items: Array,
    search: {
      type: Boolean,
      required: false,
      default: true
    },
    title: {
      type: String,
      required: true
    },
    close: {
      type: Boolean,
      required: false,
      default: false
    },
    dropType: {
      type: String,
      required: false,
      default: 'complex'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    items(newItems){
      const theDropdown = this;
      theDropdown.currentItems = newItems;
    }
  },
  computed: {
    ...mapGetters([

    ]),
    filteredItems(){
      const theDropdown = this;
      let sortedItems = [...theDropdown.currentItems];
      if(theDropdown.$props.dropType === 'simple'){
        sortedItems.sort((itemA, itemB) => {
          const nameA = itemA.toLowerCase();
          const nameB = itemB.toLowerCase();
          if(nameA < nameB){
            return -1;
          }
          if(nameA > nameB){
            return 1;
          }
          return 0;
        })
      }else{
        sortedItems.sort((itemA, itemB) => {
          const nameA = itemA.lastName.toLowerCase();
          const nameB = itemB.lastName.toLowerCase();
          if(nameA < nameB){
            return -1;
          }
          if(nameA > nameB){
            return 1;
          }
          return 0;
        })
      }

      return sortedItems.filter(theDropdown.textFilter)
    },
  },
  methods: {
    ...mapActions([

    ]),
    toggleDropdown(){
      const theDropdown = this;
      theDropdown.dropdownActive = !theDropdown.dropdownActive;
    },
    clearFilter(){
      const theDropdown = this;
      theDropdown.searchStr = null;
    },
    selectOption(option){
      const theDropdown = this;
      theDropdown.selectedOption = option
      theDropdown.dropdownActive = false
      theDropdown.$emit('update:modelValue', option.id)
    },
    selectUserType(userType){
      const theDropdown = this;
      theDropdown.selectedOption = userType
      theDropdown.dropdownActive = false
      theDropdown.$emit('update:modelValue', userType)
    },
    textFilter(s){
      const theDropdown = this;
      let userName = '';

      if(theDropdown.$props.dropType === 'simple'){
        userName = s.toLowerCase()
      }else{
        userName = (`${s.firstName} ${s.lastName}`).toLowerCase()
      }

      if(theDropdown.searchStr === null){
        return true;
      }

      if(theDropdown.searchStr.length < 1){
        return true;
      }

      if(userName.includes(theDropdown.searchStr.toLowerCase())){
        return true;
      }
    }
  },
  mounted(){

  },
  beforeUnmount(){

  },
  data: function(){
    return {
      dropdownActive: false,
      searchStr: null,
      selectedOption: null,
      currentItems: this.items
    }
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  ::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 10px;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }

  /* IE10+ */
  ::-ms-clear {
    display: none;
  }

  /* Chrome */
  ::-webkit-search-decoration,
  ::-webkit-search-cancel-button,
  ::-webkit-search-results-button,
  ::-webkit-search-results-decoration {
    display: none;
  }

  .search-dropdown-wrapper{
    position: relative;
    text-align: left;
    margin: 0 auto;
    margin-top: 10px;
    width: 100%;
  }

  .search-icon{
    position: absolute;
    top: 20%;
    right: 0px;
  }

  .dropdown-toggle{
    height: 40px;
    width: 100%;
    display: table;
    cursor: pointer;
  }

  .selected-option{
    display: table-cell;
    vertical-align: middle;
    padding-left: 10px;
    font-size:14px;
  }

  .arrow{
    position: absolute;
    top: 15px;
    right: 14px;
  }

  .dropdown{
    position: absolute;
    top: 40px;
    left: 0px;
    width: 100%;
    z-index: 5;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s;
    padding: 10px;
  }

  .dropdown-active{
    max-height: 220px;
    transition: max-height 0.2s;
  }

  .search input{
    font-size: 16px;
    height: 35px;
  }

  .options-scroll{
    height: 160px;
    overflow-x: hidden;
    overflow-y: auto;
    /*-webkit-overflow-scrolling: touch;*/
  }

  .dropdown-option{
    position: relative;
    padding: 10px 5px;
    cursor: pointer;
  }

  .clear-filter{
    position: absolute;
    top: 23px;
    right: 15px;
    cursor: pointer;
  }

  .disabled{
    opacity: .8;
    pointer-events: none;
  }
</style>
